import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleApplicationsService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { NoActions } from '../no.actions';
import {
  AppleApplicationResolverActions,
  AppleApplicationApiActions,
  AppleApplicationViewActions,
} from './apple-applications.actions';
import { UploadService } from './upload.service';
import { safeMap } from '../effects.helpers';
@Injectable()
export class AppleApplicationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: AppleApplicationsService,
    private readonly uploadApi: UploadService
  ) {}

  loadAppleApplicationsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleApplicationResolverActions.applicationsRequested),
      mergeMap(() =>
        safeMap(
          this.api.getApplications('2.0'),
          (applications) => AppleApplicationApiActions.applicationsLoaded({ applications }),
          (error) => AppleApplicationApiActions.applicationsLoadedError({ error })
        )
      )
    );
  });

  addAppleApplicationEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleApplicationViewActions.applicationAdded),
      mergeMap(({ application }) =>
        safeMap(
          this.uploadApi.addApplicationForm(application, '2.0', 'events', true),
          (event) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                return AppleApplicationApiActions.applicationUploadProgressed({
                  progress: Math.round((event.loaded / event.total) * 100),
                });
              case HttpEventType.Response:
                return AppleApplicationApiActions.applicationAdded({ application: event.body });
              default:
                return NoActions.noAction(); // Make sure that other types don't dispatch an undefined action
            }
          },
          (error) => AppleApplicationApiActions.applicationAddedError({ error })
        )
      )
    );
  });

  deleteAppleApplicationEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleApplicationViewActions.applicationDeleted),
      mergeMap(({ bundleIdentifier, version }) =>
        safeMap(
          this.api.deleteApplication(bundleIdentifier, '2.0', version),
          () => AppleApplicationApiActions.applicationDeleted({ bundleIdentifier, version }),
          (error) => AppleApplicationApiActions.applicationDeletedError({ error })
        )
      )
    );
  });
}
